import {reZoneConstants} from './constants'

const initialState =
    {
        list: [],
        isSending: false,
        error: null
    }

export default function (state = initialState, action) {
    switch (action.type) {
        case reZoneConstants.GetZones.REQUEST:
            return {
                ...state,
                isSending: true
            }
        case reZoneConstants.GetZones.FAILURE:
            return {
                ...state,
                isSending: false,
                error: action.payload
            }
        case reZoneConstants.GetZones.SUCCESS:
            return {
                ...state,
                isSending: false,
                list: action.payload.result
            }
        case reZoneConstants.ClearZones:
            return {
                ...state,
                list: []
            }
        default:
            return state
    }
}